import { ReactComponent as ZurichVerticalIcon } from "@assets/icons/zurich_vertical.svg"
import type React from "react"

type PensionCardProps = {
  contribution: string | number
  pensionApplied: "zurich_standard_prsa" | "zurich_nonstandard_prsa"
}

interface PensionVariants {
  [key: string]: {
    title: string
  }
}

const PensionCard: React.FC<PensionCardProps> = ({ contribution, pensionApplied }) => {
  const pensionsViewVariants: PensionVariants = {
    zurich_standard_prsa: {
      title: "Zurich Standard PRSA",
    },
    zurich_nonstandard_prsa: {
      title: "Zurich Non-Standard PRSA",
    },
  }

  return (
    <div className="bg-pn_white border border-pn_gray-200 rounded-2xl p-4 flex items-center gap-x-6">
      <div className="rounded-full w-[64px] h-[64px] flex items-center justify-center border-pn_gray-200 bg-pn_white border">
        <ZurichVerticalIcon />
      </div>

      <div className="gap-y-1 flex flex-col">
        <span className="text-pn_gray-950 text-pn-body-large-emphasis flex-1">
          {pensionsViewVariants[pensionApplied]?.title}
        </span>

        <div className="flex items-center gap-x-[6px]">
          <span className="text-pn-body-small-regular text-pn_gray-950">Monthly Contributions</span>
          <span className="text-pn-body-small-regular text-pn_gray-950 bg-pn_yellow-200">€{contribution}</span>
        </div>
      </div>
    </div>
  )
}
export default PensionCard
